/*eslint-disable*/
import React, { useState, useEffect } from "react";
import TopNavigationBar from "../../components/TopNavigationBar";
import PropertyDetailsDisplay from "../../components/PropertyDetailsDisplay";
import MediaSection from "../../components/PropertyMediaDisplay";
import PropertyPublishDisplay from "../../components/PropertyPublishDisplay";
import { useNavigate, useLocation } from "react-router-dom";
import { FirebaseContext } from "common";
import { useDispatch, useSelector } from "react-redux";
//
function StaffListingInfomation() {
  const { api } = React.useContext(FirebaseContext);
  const { PPTokenGenerator, fetchPPRef, clearListingErrors, getPrivatePropStatus } = api;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  let listing = location.state.item;

  const [ListingData, setListingData] = useState(listing);
  const [currentView, setCurrentView] = useState("Details");
  const [token, settoken] = useState([]);

  const tokenManagementReducer = useSelector(
    (state) => state.tokendata.token.token
  );
  const ppRefManagement = useSelector((state) => state.leaddata);



  useEffect(() => {
    console.log("ListingData in StaffListingInfomation:", ListingData);
    dispatch(PPTokenGenerator());
  }, [])


  useEffect(() => {

    if (tokenManagementReducer && ListingData) {

      console.log("Fetching PP Ref for listing:", ListingData);
      dispatch(fetchPPRef(tokenManagementReducer, ListingData));

    }
  }, [tokenManagementReducer]);



  useEffect(() => {

    if (ppRefManagement.completed && ppRefManagement.success) {
      setListingData({
        ...ListingData,
        ListingPPId: ppRefManagement.ppref,
        publishedPP: ppRefManagement.ppref ? true : false,
        PPStatus: (ListingData.PPStatus && ppRefManagement.ppref) ? ListingData.PPStatus : ppRefManagement.ppref ? (ListingData?.type === "tolet" || ListingData?.type.includes("To Let")) ? "ToLet" : "ForSale" : null
      })

     // dispatch(getPrivatePropStatus({ ...ListingData, ListingPPId: ppRefManagement.ppref }, tokenManagementReducer))

    }
  }, [ppRefManagement]);


  async function editButton() {
    //await dispatch(clearListingErrors());
    navigate("/update", { state: { item: ListingData } });
  }

  function publishButton() {
    dispatch(clearListingErrors());
    navigate("/publish", { state: { item: ListingData } });
  }

  // Render different content based on the current view
  const renderContent = () => {
    switch (currentView) {
      case "Details":
        return <PropertyDetailsDisplay listing={ListingData} />;
      case "media":
        return <MediaSection listing={ListingData} />;
      case "Publish":
        return (
          <PropertyPublishDisplay
            listingData={ListingData}
            setListingData={setListingData}
          />
        );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        justifyContent: "flex-start"
      }}
    >
      <TopNavigationBar
        currentView={currentView}
        onViewChange={setCurrentView}
        editButton={editButton}
        publishButton={publishButton}
      />

      <div style={{ flex: 1, padding: "20px" }}>{renderContent()}</div>
    </div>
  );
}

export default StaffListingInfomation;
